import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PaymentsService } from '../../services/payments.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';

/**
 * Vendor-Backed Payments report — pivots cross-ledger NA receipts by Brand /
 * Vendor / Customer / Item for a date range. Server returns one pivot per
 * request; we re-fetch when the tab changes.
 */
@Component({
	selector: 'app-vendor-backed-payments',
	templateUrl: './vendor-backed-payments.component.html',
	styleUrls: ['./vendor-backed-payments.component.scss']
})
export class VendorBackedPaymentsComponent implements OnInit {
	filterForm: UntypedFormGroup;
	pivot: 'brand' | 'vendor' | 'customer' | 'item' = 'brand';
	loading = false;

	rows: any[] = [];
	totals: any = null;

	constructor(
		private fb: UntypedFormBuilder,
		private paymentsService: PaymentsService,
		private globalSearchService: GlobalSearchService,
		private printService: PrintService,
	) {}

	ngOnInit(): void {
		const today = new Date();
		const first = new Date(today.getFullYear(), today.getMonth(), 1);
		this.filterForm = this.fb.group({
			from: [first.toISOString().substring(0, 10)],
			to: [today.toISOString().substring(0, 10)],
			vendor_id: [''],
			brand_id: [''],
			debtorno: [''],
		});
		this.load();
	}

	load() {
		this.loading = true;
		const f = this.filterForm.value;
		this.paymentsService.getVendorBackedReport({
			from: f.from,
			to: f.to,
			vendor_id: f.vendor_id || '',
			brand_id: f.brand_id || '',
			debtorno: f.debtorno || '',
			group_by: this.pivot,
		}).subscribe((r: any) => {
			this.loading = false;
			if (r?.success) {
				this.rows = r.rows || [];
				this.totals = r.totals;
			} else {
				this.rows = [];
				this.totals = null;
			}
		});
	}

	pivotTo(p: 'brand' | 'vendor' | 'customer' | 'item') {
		this.pivot = p;
		this.load();
	}

	exportCsv() {
		const header = [this.pivot, 'units', 'gross_ar', 'vendor_relief', 'commission', 'invoices', 'commission_per_unit'];
		const lines = [header.join(',')];
		for (const r of this.rows) {
			lines.push([
				JSON.stringify(r.label),
				r.units, r.gross_ar, r.vendor_relief, r.commission, r.invoices, r.commission_per_unit
			].join(','));
		}
		const csv = lines.join('\n');
		const blob = new Blob([csv], { type: 'text/csv' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `vendor-backed-${this.pivot}.csv`;
		a.click();
		URL.revokeObjectURL(url);
	}
}
